
import { Component, Vue } from "vue-property-decorator";
import ProdutoQtdeContainer from "@/components/produtos/ProdutoQtdeContainer.vue";
import PedidoTotais from "@/components/pedido/PedidoTotais.vue";
import imageService from "@/services/ImageService";
import { namespace } from "vuex-class";
import PedidoInterface from "../../interfaces/Pedido";
import QuestionDialog from '@/components/dialogs/QuestionDialog.vue';

const AppbarStore = namespace("Appbar");
const AuthStore = namespace("Auth");
const PedidoStore = namespace("Pedido");

@Component({
  name: "CarrinhoListaProdutosContainer",
  components: {
    ProdutoQtdeContainer,
    PedidoTotais,
    QuestionDialog,
  },
})
export default class CarrinhoListaProdutosContainer extends Vue {
  @PedidoStore.Getter
  private getPedido!: PedidoInterface;

  @AppbarStore.Getter
  private getAppbarStatus!: any;

  @AuthStore.Getter
  private isLoggedIn!: boolean;

  get getProdutos() {
    return this.getPedido?.produtos || [];
  }

  buildProdutoImage(produtoPedido: any) {
    const imgs = imageService.getProdutoImages(produtoPedido.produto)[0];
    const result = {
      src: imgs.img,
      "lazy-src": imgs.thumb,
    };
    return result;
  }

  onCheckoutClick() {
    if (this.$router.currentRoute.path === "/checkout") {
      this.onCloseDrawer();
      return;
    }

    this.$router.push({
      path: "/checkout",
    });
  }
  onCloseDrawer() {
    this.getAppbarStatus.carrinhoDrawer = !this.getAppbarStatus.carrinhoDrawer;
  }

  onLimparCarrinhoClick() {
    const dlg = this.$refs.dlgQuestion as any;
    dlg.show('-1', {
      title: 'Limpar Carrinho',
      message: 'Deseja remover todos os produtos do carrinho?',
      aprovarLabel: 'Ok'
    });
  }

  async handleRemoveProduto(payload: string) {
    try {
      if (payload === '-1') {
        await this.$store.dispatch('Pedido/removerTodosProdutos');
        this.onCloseDrawer();
      }
    } catch (error) {
      console.error('Erro ao remover produtos:', error);
    }
  }
}
